import React from 'react';
import PropTypes from 'prop-types';
import { ModalService, WhiteModal } from '@sm360/widget-commons-general';
import { Vehicle, Quote } from '@sm360/widget-commons-vehicle';

import OfficialTradeInWrapper from 'trade-in/components/OfficialTradeInWrapper/OfficialTradeInWrapper.jsx';

const MODAL_NAME = 'trade-in-official-modal';

const OfficialTradeInModal = ({ onClose, openModal, tradeInVehicle, quote }) => {
    const modal = ModalService.get(MODAL_NAME);
    if (openModal && !modal.isOpen()) {
        modal.open();
    }
    modal.addCallbacks({
        onClose: () => {
            onClose();
            return true;
        },
    });
    return (
        <WhiteModal
            name={MODAL_NAME}
            contentLabel="trade-in-official-modal-label"
            dataTestPrefix="trade-in.official-modal"
            isScrollable
            isClosable
        >
            <OfficialTradeInWrapper isRenderedInModal tradeInVehicle={tradeInVehicle} quote={quote} />
        </WhiteModal>
    );
};

OfficialTradeInModal.defaultProps = {
    openModal: false,
    quote: null,
};

OfficialTradeInModal.propTypes = {
    onClose: PropTypes.func.isRequired,
    openModal: PropTypes.bool,
    tradeInVehicle: PropTypes.instanceOf(Vehicle.TradeInVehicleModel).isRequired,
    quote: PropTypes.instanceOf(Quote.QuoteModel),
};

OfficialTradeInModal.displayName = 'OfficialTradeInModal';
export { MODAL_NAME };
export default OfficialTradeInModal;



// WEBPACK FOOTER //
// ./src/components/OfficialTradeInModal/OfficialTradeInModal.jsx